import { gql } from 'react-apollo';

export default gql`
  mutation updateInvestorPreferences(
    $minimumInvestmentSize: MinimumInvestmentSize!
    $averageInvestmentSize: AverageInvestmentSize!
    $preferredListingTypes: [ListingType!]!
    $preferredTransactionTypes: [TransactionType!]!
    $preferredSectors: [Sector!]!
    $preferredAreas: [Area!]!
  ) {
    updateInvestorPreferences(
      input: {
        minimumInvestmentSize: $minimumInvestmentSize
        averageInvestmentSize: $averageInvestmentSize
        preferredListingTypes: $preferredListingTypes
        preferredTransactionTypes: $preferredTransactionTypes
        preferredSectors: $preferredSectors
        preferredAreas: $preferredAreas
      }
    ) {
      _id
      accreditationStatus
      minimumInvestmentSize
      averageInvestmentSize
      preferredListingTypes
      preferredAreas
      preferredSectors
      preferredTransactionTypes
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateInvestorPreferences.js